import { styled } from "@mui/material/styles";
import { keyframes } from "@mui/system";

const blink = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

export const BlinkedBox = styled("div")(({ size, color }) => ({
  backgroundColor: color || "red",
  width: size || 10,
  height: size || 10,
  borderRadius: "50%",
  animation: `${blink} 1.5s linear infinite`,
}));
